<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="top">
          <div class="top-item">
            <span>状态</span>
            <el-radio-group v-model="replyStatus" size="small">
              <el-radio-button label>全部</el-radio-button>
              <el-radio-button label="0">未回复</el-radio-button>
              <el-radio-button label="1">已回复</el-radio-button>
            </el-radio-group>
          </div>
          <div class="top-item">
            <span>星级筛选</span>
            <el-radio-group v-model="shopScore" size="small">
              <el-radio-button label>全部</el-radio-button>
              <el-radio-button label="1">1星</el-radio-button>
              <el-radio-button label="2">2星</el-radio-button>
              <el-radio-button label="3">3星</el-radio-button>
              <el-radio-button label="4">4星</el-radio-button>
              <el-radio-button label="5">5星</el-radio-button>
            </el-radio-group>
          </div>
          <div class="top-item">
            <span>时间选择</span>
            <el-date-picker
              v-model="orderTime"
              type="daterange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              size="small"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
        </div>
        <div>
          <el-button type="primary" size="small" @click="screenData">筛选</el-button>
          <el-button @click="resetScreenData" size="small">重置</el-button>
        </div>
      </div>
      <div class="tab-content">
        <div class="content-title">
          <div class="left">
            <p>{{ info.shopScore }}</p>
            <p>综合评分</p>
            <p>高于商圈{{ info.overPercent }}%的商家</p>
          </div>
          <div class="right">
            <div v-for="(item, index) in shopScoreItem" :key="index">
              <span>{{ item.shopScore }}星</span>
              <el-progress
                :percentage="parseInt((item.commentNum / (totalCommentNum || 1)) * 100)"
                color="#ff9100"
              ></el-progress>
            </div>
          </div>
        </div>
        <div class="content-container">
          <p class="title">评论列表</p>
          <div class="list">
            <div class="item" v-for="(item, index) in commentList" :key="index">
              <div class="item-title">
                <img class="avatar" :src="item.headLogo" alt />
                <div class="info">
                  <p class="name">
                    {{ item.userName }}
                    <span class="time">{{ item.createTime }}</span>
                  </p>
                  <el-rate
                    v-model="item.shopScore"
                    disabled
                    :show-score="false"
                    text-color="#ff9100"
                    score-template="{value}"
                  ></el-rate>
                </div>
              </div>
              <div class="item-content">
                <p class="comment">{{ item.content }}</p>
                <div class="comment-img-list" v-if="item.images">
                  <img
                    @click="(isShowPreviewImg = true), (previewImg = imgItem)"
                    v-for="(imgItem, index) in item.images"
                    :key="index"
                    :src="imgItem"
                    alt
                  />
                </div>
                <div class="reply-content" v-if="item.replyContent">
                  掌柜回复：{{ item.replyContent }}
                </div>
                <div class="actions">
                  <el-link
                    icon="el-icon-chat-dot-square"
                    v-if="!item.replyContent"
                    type="primary"
                    :underline="false"
                    @click="showReplyDialog(item.customerCommentsId)"
                    >回复</el-link
                  >
                  <el-link
                    icon="el-icon-delete"
                    type="info"
                    v-if="item.replyContent"
                    :underline="false"
                    @click="delReplyByShoper(item.customerCommentsId)"
                    >删除回复</el-link
                  >
                  <el-link
                    icon="el-icon-document-checked"
                    type="primary"
                    :underline="false"
                    @click="checkOrder(item.tradeNo)"
                    >查看订单</el-link
                  >
                  <el-link
                    icon="el-icon-delete"
                    type="info"
                    :underline="false"
                    @click="delCommentsByShoper(item.customerCommentsId)"
                    >删除</el-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
      :visible.sync="replyVisible"
    >
      <div slot="title" class="dialog-title">回复评论</div>
      <el-form label-width="88px" class="orderpay-form">
        <el-form-item label="回复内容">
          <el-input
            type="textarea"
            v-model="replyContent"
            :rows="4"
            placeholder="请输入回复内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="replyComment" :loading="isSubmit"
          >回复</el-button
        >
        <el-button @click="replyVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="isShowPreviewImg" width="500px">
      <img width="100%" :src="previewImg" alt />
    </el-dialog>
  </div>
</template>

<script>
import {
  getCustomerComments,
  getStatisticsComments,
  delReplyByShoper,
  replyByShoper,
  delCommentsByShoper,
} from "@/api";
import { mapState } from "vuex";
import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      isShowPreviewImg: false,
      previewImg: "",
      replyStatus: "",
      shopScore: "",
      orderTime: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近7日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近30日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近90日",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      shopScoreItem: [
        {
          commentNum: 0,
          overPercent: 0,
          replyContent: "",
          shopScore: 1,
        },
        {
          commentNum: 0,
          overPercent: 0,
          replyContent: "",
          shopScore: 2,
        },
        {
          commentNum: 0,
          overPercent: 0,
          replyContent: "",
          shopScore: 3,
        },
        {
          commentNum: 0,
          overPercent: 0,
          replyContent: "",
          shopScore: 4,
        },
        {
          commentNum: 0,
          overPercent: 0,
          replyContent: "",
          shopScore: 5,
        },
      ],
      info: {},
      commentList: [],
      totalCommentNum: 1,
      replyVisible: false,
      commentId: "",
      replyContent: "",
      isSubmit: false,
    };
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
      isOwn: (state) => state.isOwn,
    }),
  },
  watch: {},
  mounted() {
    this.replyStatus = this.$route.params.replyStatus || "";
    this.shopScore = this.$route.params.shopScore || "";
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.getCustomerComments();
      this.getStatisticsComments();
    },
    getNextData() {
      this.getCustomerComments();
      this.getStatisticsComments();
    },
    getCustomerComments() {
      getCustomerComments({
        row: 1000,
        replyStatus: this.replyStatus,
        shopScore: this.shopScore,
        startDate:
          this.orderTime && this.orderTime.length
            ? new Date(this.orderTime[0]).pattern("yyyy-MM-dd")
            : "",
        endDate:
          this.orderTime && this.orderTime.length
            ? new Date(this.orderTime[1]).pattern("yyyy-MM-dd")
            : "",
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            val.images = val.images && val.images.length ? val.images.split(",") : [];
          });
          this.commentList = res.data;
        }
        if (res.code == -1) {
          this.commentList = [];
        }
      });
    },
    getStatisticsComments() {
      getStatisticsComments().then((res) => {
        if (res.code == 1) {
          this.shopScoreItem.forEach((val) => {
            this.totalCommentNum = 0;
            res.data.shopScoreItem.forEach((subval) => {
              if (val.shopScore == subval.shopScore) {
                val.commentNum = subval.commentNum || 0;
                val.overPercent = subval.overPercent || 0;
                val.replyContent = val.replyContent;
              }
              this.totalCommentNum += subval.commentNum;
            });
          });
          this.info = res.data.info;
        }
      });
    },
    resetScreenData() {
      this.replyStatus = "";
      this.shopScore = "";
      this.orderTime = [];
      this.getNextData();
    },
    screenData() {
      this.getNextData();
    },
    delCommentsByShoper(id) {
      console.log(id, "commentId");
      // return
      this.$msgbox({
        title: "消息",
        message: `是否删除，删除后将无法恢复！`,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delCommentsByShoper({
              commentId: id,
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "删除成功",
                  type: "success",
                });
                this.getNextData();
              }
            });
            done();
          } else {
            done();
          }
        },
      }).then((action) => {});
    },
    delReplyByShoper(id) {
      delReplyByShoper({
        commentId: id,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "删除成功",
            type: "success",
          });
          this.getNextData();
        }
      });
    },
    replyComment() {
      this.isSubmit = true;
      replyByShoper({
        commentId: this.commentId,
        content: this.replyContent,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "回复成功",
            type: "success",
            duration: 2000,
          });
          this.getNextData();
          this.replyVisible = false;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
        this.isSubmit = false;
      });
    },
    showReplyDialog(id) {
      this.commentId = id;
      this.replyContent = "";
      this.replyVisible = true;
    },
    checkOrder(orderid) {
      if (this.shopInfo.edcShopType == 8) {
        this.$router.push({
          name: "orderService",
          params: {
            tradeNo: orderid,
          },
        });
      } else if (this.isDsType) {
        this.$router.push({
          name: "dsOrder",
          params: {
            tradeNo: orderid,
          },
        });
      } else {
        this.$router.push({
          name: "order",
          params: {
            tradeNo: orderid,
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  overflow: hidden;
  .bd {
    height: 100%;
  }
  .tab-header {
    height: 124px;
    box-sizing: border-box;
    .top {
      display: flex;
      margin-bottom: 20px;
      white-space: nowrap;
      .top-item {
        display: flex;
        flex: 1;
        align-items: center;
        margin-right: 66px;
        span {
          white-space: nowrap;
          margin-right: 10px;
          font-size: 12px;
          color: #333333;
          font-weight: bold;
        }
        .el-select {
          width: 100%;
        }
      }
    }
  }
  .tab-content {
    display: block;
    padding: 0 40px 0 20px;
    height: calc(100% - 124px);
    .content-title {
      padding: 34px 0 0 0;
      margin-bottom: 50px;
      .left {
        display: inline-block;
        padding-right: 94px;
        border-right: 1px solid #eeeeee;
        & > p:first-child {
          font-size: 48px;
          line-height: 48px;
          color: #ff9100;
          margin-bottom: 16px;
        }
        & > p:nth-child(2) {
          font-size: 14px;
          line-height: 14px;
          color: #666666;
          margin-bottom: 16px;
        }
        & > p:nth-child(3) {
          font-size: 14px;
          line-height: 14px;
          color: #999999;
          margin-bottom: 14px;
        }
      }
      .right {
        display: inline-block;
        width: 200px;
        padding-left: 86px;
        & > div {
          display: flex;
          line-height: 24px;
          span {
            width: 40px;
            font-size: 14px;
            color: #666666;
          }
          .el-progress {
            width: 100%;
            white-space: nowrap;
          }
        }
      }
    }
    .content-container {
      height: calc(100% - 163px);
      .title {
        font-size: 16px;
        color: #273c57;
        line-height: 48px;
        border-bottom: 1px solid #eeeeee;
      }
      .list {
        height: calc(100% - 99px);
        overflow: auto;
        .item {
          border-bottom: 1px solid #eeeeee;
          padding-bottom: 28px;
          .item-title {
            margin-top: 20px;
            .avatar {
              width: 48px;
              height: 48px;
              min-width: 48px;
              border-radius: 50%;
              vertical-align: top;
            }
            .info {
              display: inline-block;
              margin-left: 16px;
              .name {
                font-size: 14px;
                line-height: 24px;
                color: #273c57;
                margin-bottom: 3px;
                .time {
                  color: #bbbbbb;
                  margin-left: 18px;
                }
              }
            }
          }
          .item-content {
            padding-left: 64px;
            .comment {
              font-size: 12px;
              line-height: 32px;
              color: #999999;
            }
            .comment-img-list {
              margin-bottom: 10px;
              img {
                width: 60px;
                height: 60px;
                object-fit: cover;
                margin-right: 10px;
              }
            }
            .reply-content {
              position: relative;
              background: #f8f8f8;
              padding: 20px 12px;
              margin-bottom: 12px;
              font-size: 12px;
              color: #ff9100;
              &::before {
                content: "";
                width: 6px;
                height: 6px;
                background: #f8f8f8;
                position: absolute;
                top: -4px;
                left: 18px;
                transform: rotate(45deg);
              }
            }
            .actions {
              .el-link {
                margin-right: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
.right {
  .el-progress__text {
    color: #e99322;
  }
}
</style>
